var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "文本位置" } },
        [
          _c(
            "el-select",
            {
              staticClass: "setting-line-text-position",
              model: {
                value: _vm.textPosition,
                callback: function($$v) {
                  _vm.textPosition = $$v
                },
                expression: "textPosition"
              }
            },
            [
              _c("el-option", {
                attrs: { value: "flex-start", label: "左边" }
              }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "center", label: "中间" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "flex-end", label: "右边" } })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e154788", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e154788","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/base_setting/SettingLineTextPosition.vue
// module id = null
// module chunks = 